module.exports = __webpack_public_path__ + "static/media/opentable.9732b17c.svg";